import { render } from "./RequestQuotePage.vue?vue&type=template&id=35a69330&scoped=true&lang=html"
import script from "./RequestQuotePage.vue?vue&type=script&lang=js"
export * from "./RequestQuotePage.vue?vue&type=script&lang=js"

import "./RequestQuotePage.vue?vue&type=style&index=0&id=35a69330&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a69330"]])

export default __exports__